import { Box, Stack } from '@mui/material';
import { FC } from 'react';
import { createUseStyles } from 'react-jss';
import Text from '../text';
import Icon from '../icon';

interface Props {
  title: string;
  onClose: () => void;
  hideClose?: boolean;
}

const useStyles = createUseStyles({
  closeButton: {
    position: 'absolute',
    top: -5,
    right: -8,
  },
});

const MenuHeader: FC<Props> = ({ title, onClose, hideClose = false }) => {
  const styles = useStyles();
  return (
    <Stack
      px={1}
      pb={1}
      position="relative"
      direction="row"
      justifyContent="space-between"
      alignItems="center"
    >
      <Box>
        <Text bold>{title}</Text>
      </Box>
      {!hideClose && (
        <Icon name="close" onClick={onClose} size="small" className={styles.closeButton} />
      )}
    </Stack>
  );
};

export default MenuHeader;
